import axios from 'axios';

import {ActionType} from '../actionTypes';

import envManager from '../../com/envManager/EnvManager';

import {Action as PagesActions} from "../actions/pagesActions";
import {Action as ProgressPopupActions} from "../actions/uploadingImagesProgressActions";
import {Action as FlyersActions} from "../actions/flyersActions";


import {Dispatch} from 'redux';
import {
    ErrorDtoFactory,
    FlyerPageDto, FlyerPagesAfterWMDto,
    FlyerPageSpotDto,
    InsertPageDto,
    MovePagesDto,
    PagesDto,
    PromoDto,
    PromoItemsDto,
    SelectPageForTabsDto,
    UploadImagesToPagesDto, UploadProgressingImagesDto,
    UserDto
} from '../../dtos';
import {FlyerDetailsState} from "../reducers/flyerDetailsReducer";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";

export const deletePageFromPages = (pageData: PagesDto) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<PagesActions>) => {
        dispatch({
            type: ActionType.DELETE_PAGE
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'pages': pageData.pages,
                'uiLanguageCultureCode': pageData.uiLanguageCultureCode
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPages/DeletePages`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.DELETE_PAGE_SUCCESS,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_PAGE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const deleteImagesFromPages = (pageData: PagesDto) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<PagesActions>) => {
        dispatch({
            type: ActionType.DELETE_PAGE_IMAGE
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'pages': pageData.pages,
                'uiLanguageCultureCode': pageData.uiLanguageCultureCode
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPages/DeletePageImages`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.DELETE_PAGE_IMAGE_SUCCESS,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_PAGE_IMAGE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const insertPageToFlyer = (pageData?: InsertPageDto) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<PagesActions>) => {
        dispatch({
            type: ActionType.INSERT_PAGE
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'pageNo': pageData?.pageNo,
                'uiLanguageCultureCode': pageData?.uiLanguageCultureCode,
                'flyerId': pageData?.flyerRecID
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPages/InsertNewFlyerPage`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.INSERT_PAGE_SUCCESS,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.INSERT_PAGE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const movePageBeforeInFlyer = (pageData?: MovePagesDto) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<PagesActions>) => {
        dispatch({
            type: ActionType.MOVE_PAGES_BEFORE
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'pageNo': pageData?.pageNo,
                'uiLanguageCultureCode': pageData?.uiLanguageCultureCode,
                'flyerPages': pageData?.flyerPages
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPages/MoveAndRepaginatePages`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            dispatch({
                type: ActionType.MOVE_PAGES_BEFORE_SUCCESS,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.MOVE_PAGES_BEFORE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const uploadImagesToPages = (uploadData: UploadImagesToPagesDto) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    const formData = new FormData();
    formData.append("UserId", JSON.stringify(userDto.userId));
    // formData.append("FirstPageId", JSON.stringify(uploadData.FirstPageId));
    // formData.append("Pages", JSON.stringify(uploadData.Pages));
    formData.append("UiLanguageCultureCode", JSON.stringify(uploadData.UiLanguageCultureCode));
    for (let i = 0; i < uploadData.Images.length; i++) {
        const img: any = uploadData.Images[i];
        //
        if (img.file !== null && img.file !== undefined) {
            formData.append(`Images`, img.file!, img.file!.name);
        } else {
            formData.append(`Images`, new Blob(), '');
        }
    }
    for (let i = 0; i < uploadData.Pages.length; i++) {
        const page: any = uploadData.Pages[i];
        formData.append(`Pages`, page.flpRecId);
    }


    return async (dispatch: Dispatch<PagesActions | ProgressPopupActions | FlyersActions>) => {
        dispatch({
            type: ActionType.UPLOAD_IMAGES_TO_PAGES
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + userDto.token
                },
                onUploadProgress: (progressEvent : any) => {
                    const data: UploadProgressingImagesDto = {
                        isUploadingFilesToSystem: progressEvent.loaded !== progressEvent.total,
                        isUploadingFilesToSystemFinished: progressEvent.loaded === progressEvent.total,
                        current: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.loaded,
                        failCount: 0,
                        processingFinished: false,
                        successCount: 0,
                        severityLevel: '',
                        total: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.total,
                        titlePopup: `Uploading file...`,
                        notUploadedImages: null,
                    }
                    dispatch({
                        type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE,
                        payload: data
                    });
                },
            }


            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPages/UploadPageImagesToPages`;
            let result = await axios.post(url, formData, config);
            let updatedPages = result.data.data;


            dispatch({
                type: ActionType.UPLOAD_IMAGES_TO_PAGES_SUCCESS,
                // payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR
            })
            dispatch({
                type: ActionType.UPLOAD_IMAGES_TO_PAGES_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const setSelectedPageForTabs = (data: SelectPageForTabsDto) => {
    return async (dispatch: Dispatch<PagesActions>) => {
        dispatch({
            type: ActionType.SET_SELECTED_PAGE_FOR_TABS,
            payload: data
        })
    }
}

export const changeQualificationStatusForPage = (
    flyerPagesIds: number[],
    languageCultureCode: string,
    qualificationLevel: number,
    flyerState: FlyerDetailsState,
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<PagesActions | FlyerDetailsActions>
    ) => {
        dispatch({
            type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_START,
        });

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerPageIds': flyerPagesIds,
                'uiLanguageCultureCode': languageCultureCode,
                'qualificationLevel': qualificationLevel,
                'flyerId': flyerState.flyRecId
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPages/SetFlyerPagesQualification`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            const updatedPages: FlyerPagesAfterWMDto[] = data.data;
            const newState = {...flyerState}
            newState.flyerPages.forEach((page: FlyerPageDto) => {
                const updatedPageInCurrentFlyer = updatedPages.find((updatedPage: FlyerPagesAfterWMDto) => updatedPage.pageId === page.flpRecId);
                if (updatedPageInCurrentFlyer) {
                    page.qualificationLevel = updatedPageInCurrentFlyer.qualification;
                    if (updatedPageInCurrentFlyer.qualification === 2) {
                        page.flyerPageSpots?.forEach((frame: FlyerPageSpotDto) => {
                            frame.qualificationLevel = updatedPageInCurrentFlyer.qualification;
                            frame.flyerPromos?.forEach((promo: PromoDto) => {
                                promo.qualificationLevel = updatedPageInCurrentFlyer.qualification;
                                promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                                    item.qualificationLevel = updatedPageInCurrentFlyer.qualification;
                                })
                            })
                        })
                    }
                }
            })
            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: newState,
            });

            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_SUCCESS,
                payload: data
            });


            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    };
};

